import React from "react";
import { Button } from "react-bootstrap";

import { useTranslation } from "react-i18next";

export default function ImportCsvButton({ handler, disabled }) {
  const {
    t,
  } = useTranslation();

  return (
    <div className="float-right mr-2">
      <Button disabled={disabled} onClick={handler} variant="info" size="md" className="btn-outline" title={t("common.labels.importFromCsv")}>
        <i className="fa fa-file-upload fa-lg" />
      </Button>
    </div>
  );
}
